var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%","display":"flex"}},[(
      _vm.$route.fullPath != '/login' && _vm.$route.fullPath != '/login/registerpage'
    )?_c('Navbar',{attrs:{"select-value":_vm.selectValue}}):_vm._e(),_c('div',{staticClass:"pagebox"},[(
        _vm.$route.fullPath != '/login' &&
        _vm.$route.fullPath != '/login/registerpage'
      )?_c('Header',{scopedSlots:_vm._u([{key:"changebtn",fn:function(){return [_c('div',{staticClass:"iconsbox",on:{"click":_vm.changeselectValueFn}},[(_vm.selectValue)?_c('i',{staticClass:"el-icon-s-fold big"}):_c('i',{staticClass:"el-icon-s-unfold big"})])]},proxy:true}],null,false,3719320568)}):_vm._e(),_c('div',{attrs:{"id":"app"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }